module.exports = __webpack_public_path__ + "media/images/tailwind/up-arrow-86b7c666149c1113ea1256a7adfc54a3.png";